import SEO from '../../components/SEO';
import React, { useState } from 'react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import AppointmentModal from '../../components/AppointmentModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SocialEngagementPage = () => {
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const insuranceRes = await axios.get(`${API}/insurance`);
        setInsuranceProviders(insuranceRes.data);
      } catch (error) {
        // Error handled silently
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Social Engagement Program" description="Community-based social engagement and support services for individuals with mental health conditions. Building connections and life skills at SDORA Wellbeing, Pikesville, MD." path="/services/social-engagement" />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-yellow-500 to-orange-500 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Social & Community Engagement
          </h1>
          <p className="text-xl md:text-2xl text-yellow-100 max-w-3xl">
            Build meaningful connections and discover purpose through community activities and shared experiences.
          </p>
        </div>
      </div>

      {/* Service Description */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">What is Social & Community Engagement?</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Social & Community Engagement supports positive relationships, purpose, resilience, and community connection. We help clients engage with like-minded individuals through clubs, community events, volunteering, and recreational activities such as karaoke, bowling, yoga, painting events, community brunches, games, cookouts, beach getaways, tours, and talent shows.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-yellow-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Reduced isolation and loneliness</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-yellow-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Sense of belonging and shared purpose</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-yellow-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">New friendships and supportive networks</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-yellow-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Joyful, meaningful experiences that foster hope and healing</span>
              </li>
            </ul>

            <button
              onClick={() => setShowAppointmentModal(true)}
              className="w-full md:w-auto bg-yellow-600 text-white px-8 py-4 rounded-lg hover:bg-yellow-700 transition-colors font-semibold text-lg"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>

      <Footer />
      
      {showAppointmentModal && (
        <AppointmentModal 
          onClose={() => setShowAppointmentModal(false)}
          insuranceProviders={insuranceProviders}
        />
      )}
    </div>
  );
};

export default SocialEngagementPage;